import { useGlobalState, useSelectors } from '@exodus/headless-react';
import { useSelector } from 'react-redux';
const DEFAULT_SLIPPAGE = 3;
const useSlippage = () => {
    const selectors = useSelectors();
    const remoteConfigDefaultSlippage = useSelector(selectors.remoteConfig.get('infrastructure.exchange.defaultSlippage'));
    return useGlobalState({
        namespace: 'exchange',
        key: 'slippage',
        defaultValue: remoteConfigDefaultSlippage ?? DEFAULT_SLIPPAGE,
        persist: true,
    });
};
export default useSlippage;
